import React from "react";
import PropTypes from "prop-types";

import useStrategyBenchmarkChart from "../../../../../hooks/useStrategyBenchmarkChart";
import withTranslations from "../../../../../hocs/withTranslations";
import {
  getStrategyBenchmarkChartConfig,
  STRATEGY_BENCHMARK_CHART_FULLSCREEN_KEY,
  STRATEGY_BENCHMARK_CHART_STRATEGIES
} from "../../../../../lib/StrategyBenchmarkChart/strategyBenchmarkChartConfig";
import Loader from "../../Loader";
import StrategyBenchmarkChartFullscreenModal from "../components/StrategyBenchmarkChartFullscreenModal";
import StrategyBenchmarkChartView from "../components/StrategyBenchmarkChartView";

import "../styles/default.scss";

const StrategyBenchmarkChart = ({
  strategy,
  translate,
  locale,
  markets,
  selectedMarket
}) => {
  const strategyConfig = getStrategyBenchmarkChartConfig(strategy);
  const chartState = useStrategyBenchmarkChart({
    strategy,
    markets,
    selectedMarket
  });

  const {
    comparisonType,
    setComparisonType,
    comparisonOptions,
    timeframe,
    setTimeframe,
    isFullscreenOpen,
    openFullscreen,
    closeFullscreen,
    chartSeries,
    rates,
    isInitialLoading,
    isRefetching,
    timeframeOptions,
    marketOptions,
    selectedMarket: resolvedSelectedMarket,
    setSelectedMarket
  } = chartState;

  const hasMarkets = Array.isArray(markets) && markets.length > 0;
  const marketProps = hasMarkets
    ? {
        selectedMarket: resolvedSelectedMarket,
        marketOptions,
        onMarketChange: setSelectedMarket
      }
    : undefined;

  const viewProps = {
    locale,
    translate,
    chartTitle: translate(strategyConfig.titleKey),
    strategyLabelKey: strategyConfig.strategyLabelKey,
    chartSeries,
    comparisonType,
    comparisonOptions,
    rates,
    onComparisonChange: setComparisonType,
    timeframe,
    timeframeOptions,
    onTimeframeChange: setTimeframe,
    onFullscreenClick: openFullscreen,
    fullscreenLabel: translate(STRATEGY_BENCHMARK_CHART_FULLSCREEN_KEY),
    isRefetching,
    ...marketProps
  };

  return (
    <div className="strategy-benchmark-chart">
      {isInitialLoading ? (
        <div className="strategy-benchmark-chart__card strategy-benchmark-chart__card--loading">
          <Loader small />
        </div>
      ) : (
        <>
          <StrategyBenchmarkChartView {...viewProps} />
          <StrategyBenchmarkChartFullscreenModal
            open={isFullscreenOpen}
            onClose={closeFullscreen}
          >
            <StrategyBenchmarkChartView {...viewProps} isFullscreen />
          </StrategyBenchmarkChartFullscreenModal>
        </>
      )}
    </div>
  );
};

StrategyBenchmarkChart.propTypes = {
  strategy: PropTypes.oneOf([...STRATEGY_BENCHMARK_CHART_STRATEGIES])
    .isRequired,
  locale: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  markets: PropTypes.arrayOf(PropTypes.string),
  selectedMarket: PropTypes.string
};

export default withTranslations(StrategyBenchmarkChart);
